import type { TranslationKeys } from '@vocab/core';
import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';
import React, { type FC } from 'react';

import type { YourCandidateStatus } from '../graphql/hirer-types.generated';

import translations from './.vocab';

interface StatusBadgeProps {
  status: YourCandidateStatus;
}

type StatusTranslationKey = TranslationKeys<typeof translations>;

const statusTranslationMap: Record<
  StatusBadgeProps['status'],
  StatusTranslationKey
> = {
  NEW: 'New',
  VIEWED: 'Inbox',
  PRESCREEN: 'Prescreen',
  SHORTLIST: 'Shortlist',
  INTERVIEW: 'Interview',
  OFFER: 'Offer',
  ACCEPT: 'Accept',
  REJECTED: 'Not Suitable',
};

export const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  const { t } = useTranslations(translations);

  const translationKey = statusTranslationMap[status];

  return (
    <Badge tone={status === 'NEW' ? 'positive' : 'neutral'}>
      {t(translationKey)}
    </Badge>
  );
};
